// Mutations
export const SET_SKILL_GROUPS = 'SET_SKILL_GROUPS';
export const SET_IS_LOADING = 'SET_IS_LOADING';



// WEBPACK FOOTER //
// ./src/taskflex/skills/store/_types.js